import { observer } from 'mobx-react-lite'
import { ContainerHeader, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const DoubleOptInHeader = observer(() => {
  return (
    <ContainerHeader
      customTitle={
        <header className={styles.header}>
          <Typography variant='heading-lg' ariaLabel='Organization header'>
            Organization
          </Typography>
          <Typography
            className={styles.headerDescription}
            variant='body-md-regular'
            ariaLabel='Organization settings description'
          >
            Manage your organization settings
          </Typography>
        </header>
      }
      paddingTop={65}
      paddingBottom={0}
      paddingLeft={0}
      paddingRight={0}
      isAutoHeight={true}
    />
  )
})
